export default {
  meta: {
    locales: {
      data: [],
      isLoading: false,
      error: '',
    },
  },
  show: {
    isLoading: false,
    error: '',
    data: {},
  },
  update: {
    isLoading: false,
    error: '',
  },
};
